module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/battle-payments-clan-landing-big.0d3627ef.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/battle-payments-clan-landing-big.png
// module id = 3706
// module chunks = 11